<template>
  <div class="workSchedule">
    <Panel header="Lịch trực (Click vào ô trong lịch để xem chi tiết)">
      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <div class="flex min-w-0 flex-col md:col-span-12 lg:col-span-8">
          <Panel>
            <FullCalendar :options="calendarOptions" class="text-xs" />
          </Panel>
        </div>
        <div class="flex min-w-0 flex-col p-0 md:col-span-12 lg:col-span-4">
          <Panel
            v-if="checkSelect"
            :header="dateString"
            class="h-full text-red-600"
          >
            <label
              v-if="listSelect.length < 1"
              class="text-[13px] font-extrabold text-red-600"
              >**Chưa có lịch phân công**</label
            >
            <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
              <div class="flex min-w-0 flex-col md:col-span-12">
                <Panel header="Thêm nhân viên trực" class="text-[13px]">
                  <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                    <div class="flex min-w-0 flex-col md:col-span-12">
                      <label>Chọn thành viên</label>
                      <Dropdown
                        v-model="customer.idMember"
                        :options="listCustomer"
                        optionLabel="name"
                        optionValue="idMember"
                        :filter="true"
                        class="text-[13px]"
                      >
                        <template #option="slotProps">
                          <div class="flex items-center gap-2">
                            <img
                              v-if="slotProps.option.imageUrl"
                              :src="slotProps.option.imageUrl"
                              class="mr-1 h-5 w-5 rounded object-cover"
                            />
                            <label
                              class="m-0 text-[13px] font-medium text-slate-800"
                              >{{ slotProps.option.name }}</label
                            >
                          </div>
                        </template>
                      </Dropdown>
                    </div>
                    <div class="flex min-w-0 flex-col md:col-span-12">
                      <label>Thêm</label>
                      <Button
                        label="Thêm"
                        icon="pi pi-plus-circle"
                        iconPos="left"
                        @click="addWorkSchedule(customer.idMember)"
                        class="text-[13px]"
                      />
                    </div>
                  </div>
                </Panel>
              </div>
              <div class="flex min-w-0 flex-col md:col-span-12">
                <Panel header="Danh sách nhân viên trực">
                  <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                    <div class="flex min-w-0 flex-col md:col-span-12">
                      <DataTable
                        :value="listSelect"
                        :paginator="true"
                        scrollable
                        showGridlines
                        stripedRows
                        :rows="10"
                        :rowsPerPageOptions="[10, 25, 50]"
                        :rowHover="true"
                        v-model:filters="filters"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :globalFilterFields="['fullName']"
                        currentPageReportTemplate="Có tổng số {totalRecords} thành viên"
                        columnResizeMode="fit | expand"
                        tableclass="text-[13px]"
                      >
                        <template #header>
                          <div
                            class="flex flex-wrap items-center justify-between gap-3"
                          >
                            <div class="flex items-center gap-3 w-full">
                              <Button
                                type="button"
                                icon="pi pi-filter-slash"
                                label="Xoá lọc"
                                outlined
                                @click="clearFilter()"
                              />
                              <span class="relative inline-flex w-full">
                                <i
                                  class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400"
                                />
                                <InputText
                                  class="!pl-9 text-[13px] !w-full"
                                  v-model="filters['global'].value"
                                  placeholder="Tìm theo tên hoặc số điện thoại"
                                />
                              </span>
                            </div>
                          </div>
                        </template>

                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </template>-->
                        <!--                      </Column>-->
                        <Column field="fullName" header="Tên" sortable></Column>
                        <Column header="Tuỳ chọn">
                          <template #body="slotProps">
                            <Button
                              severity="danger"
                              label="Xoá"
                              icon="pi pi-trash"
                              @click="deleteWorkSchedule(slotProps.data.id)"
                              class="max-w-[100px] text-[13px]"
                            >
                            </Button>
                          </template>
                        </Column>
                      </DataTable>
                    </div>
                  </div>
                </Panel>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </Panel>
  </div>

  <!-- Confirm Delete Modal -->
  <ConfirmDeleteModal
    v-model="showConfirmModal"
    :title="confirmTitle"
    :message="confirmMessage"
    :is-loading="isConfirming"
    @confirm="confirmDelete.confirm"
    @cancel="confirmDelete.cancel"
  />
</template>

<script lang="ts">
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ref } from "vue";
import { WorkSchedule } from "@/models/workSchedule";
import zaloRepository from "@/services/ZaloRepository";
import { useToast } from "@/ui/services/toast";
import { ListCustomer } from "@/models/listCustomer";
import { FilterMatchMode } from "@/ui/services/api";
import { WorkScheduleDetail } from "@/models/workScheduleDetail";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Calendar } from "@fullcalendar/core";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import viLocale from "@fullcalendar/core/locales/vi";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";

export default {
  components: {
    FullCalendar,
    ConfirmDeleteModal,
  },
  setup() {
    const listWorkSchedule = ref([] as WorkSchedule[]);
    const listSelect = ref([] as WorkScheduleDetail[]);
    const toast = useToast();
    const workSchedule = ref({} as WorkSchedule);
    const date = ref();
    const checkSelect = ref(false);
    const customer = ref({} as ListCustomer);
    const dateString = ref("");

    // Use confirm delete composable
    const confirmDelete = useConfirmDelete();
    const showConfirmModal = confirmDelete.isOpen;
    const confirmTitle = confirmDelete.title;
    const confirmMessage = confirmDelete.message;
    const isConfirming = confirmDelete.isLoading;

    const formatDateTime = (date) => {
      return moment(String(date)).format("DD/MM/YYYY");
    };
    const handleDateClick = (arg) => {
      checkSelect.value = true;
      console.log("@@@@@############ debug handleDateClick: " + arg.dateStr);
      listSelect.value = [];

      listWorkSchedule.value.forEach((x) => {
        if (x.timeString == arg.dateStr) {
          const workScheduleDetail = ref({} as WorkScheduleDetail);
          workScheduleDetail.value.fullName = x.fullName;
          workScheduleDetail.value.id = x.id;
          listCustomer.value.forEach((y) => {
            if (y.id == x.zaloId)
              workScheduleDetail.value.imageLink = y.imageUrl;
          });
          listSelect.value.push(workScheduleDetail.value);
        }
      });
      date.value = arg.dateStr;
      dateString.value =
        "Ngày " +
        arg.dateStr.split("-")[2] +
        "/" +
        arg.dateStr.split("-")[1] +
        "/" +
        arg.dateStr.split("-")[0];
      console.log("@@@@@############ debug date: " + date.value);
    };

    const eventDropNow = () => {
      console.log("@@@@@############ debug eventDrop: ");
    };

    const initEvent = ($event) => {
      console.log("@@@@@############ initEvent: ");
      return null;
    };
    const calendarOptions = ref({
      plugins: [dayGridPlugin, interactionPlugin, bootstrap5Plugin],
      initialView: "dayGridMonth",
      dateClick: handleDateClick,
      events: [{ title: "", date: "" }],
      //initialEvents: initEvent,
      selectable: true,
      themeSystem: "bootstrap5",
      // timeZone: 'UTC',
      timeZone: "Asia/Ho_Chi_Minh",
      locale: "vi",
      locales: [viLocale],
      // end: 'today prev,next',
      headerToolbar: {
        today: "today",
        month: "month",
        week: "week",
        day: "day",
        list: "list",
      },
      weekNumbers: true,
      eventDrop: eventDropNow,
    });

    const loadListWorkSchedule = () => {
      zaloRepository
        .getListWorkSchedule()
        .then((response) => {
          listWorkSchedule.value = response.data;
          calendarOptions.value.events = [];
          listWorkSchedule.value.forEach((x) => {
            calendarOptions.value.events.push({
              title: x.fullName,
              date: x.timeString,
            });
          });
          listSelect.value = [];
          listWorkSchedule.value.forEach((x) => {
            if (x.timeString == date.value) {
              const workScheduleDetail = ref({} as WorkScheduleDetail);
              workScheduleDetail.value.fullName = x.fullName;
              workScheduleDetail.value.id = x.id;
              listCustomer.value.forEach((y) => {
                if (y.id == x.zaloId)
                  workScheduleDetail.value.imageLink = y.imageUrl;
              });
              listSelect.value.push(workScheduleDetail.value);
            }
          });
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        });
    };
    const listCustomer = ref([] as ListCustomer[]);

    const loadListMember = () => {
      zaloRepository
        .getListCustomer()
        .then((response) => {
          listCustomer.value = response.data;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        });
    };
    loadListMember();
    loadListWorkSchedule();
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    };
    const deleteWorkSchedule = (id) => {
      confirmDelete.open({
        title: "Xác nhận xoá",
        message: "Bạn có chắc chắn muốn xoá nhân viên ra khỏi lịch?",
        onConfirm: async () => {
          await zaloRepository.deleteWorkSchedule(id);
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá nhân viên ra khỏi lịch thành công",
            life: 3000,
          });
          listWorkSchedule.value = [];
          loadListMember();
          loadListWorkSchedule();
        },
      });
    };

    const addWorkSchedule = (id) => {
      const workSchedule = ref({} as WorkSchedule);

      listCustomer.value.forEach((x) => {
        if (x.idMember == id) {
          workSchedule.value.fullName = x.name;
          workSchedule.value.zaloId = x.id;
          workSchedule.value.timeString = date.value;
        }
      });
      zaloRepository
        .addWorkSchedule(workSchedule.value)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Thêm lịch",
            detail: "Thêm nhân viên vào lịch thành công",
            life: 3000,
          });
          // listWorkSchedule.value = [];
          console.log(
            "@@@@@############ debug addWorkSchedule listWorkSchedule: " +
              JSON.stringify(listWorkSchedule.value),
          );
          loadListMember();
          loadListWorkSchedule();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        });
    };

    return {
      calendarOptions,
      workSchedule,
      listCustomer,
      listSelect,
      filters,
      clearFilter,
      initFilters,
      deleteWorkSchedule,
      addWorkSchedule,
      checkSelect,
      customer,
      date,
      dateString,
      // Confirm delete modal
      showConfirmModal,
      confirmTitle,
      confirmMessage,
      isConfirming,
      confirmDelete,
    };
  },
};
</script>
`r`n
